export default "__VITE_ASSET__CvaLfP4N__"